<template>
    <div class="w-full xl:px-10 px-5 pt-12"><slot></slot>
    </div>
</template>

<style>
.link-color{
 color: #39a8d8;
}
</style>